module.exports = __webpack_public_path__ + "static/media/pdf-icon.904e93b5.svg";